import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const fetchAppCustomization = createAsyncThunk(
    'appCustomization/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BASE_SERVER}/app-customization`, {
                credentials: 'include',
            })
            const json = await res.json()
            if (!json.ok) throw new Error('Invalid response')
            return json.data
        } catch (err) {
            return rejectWithValue(err.message)
        }
    }
)

const appSlice = createSlice({
    name: 'appCustomization',
    initialState: {
        data: null,         // { premium_user_ads, registration_approval, ... }
        status: 'idle',     // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },
    reducers: {
        clearAppCustomization(state) {
            state.data = null
            state.status = 'idle'
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppCustomization.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(fetchAppCustomization.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.data = action.payload
            })
            .addCase(fetchAppCustomization.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.payload
            })
    },
})

export const { clearAppCustomization } = appSlice.actions
export const selectPremiumUserAds = (state) =>
    !!(state.app.data?.pop_up_for_premium);
export const selectFreemiumUserAds = (state) =>
    !!(state.app.data?.pop_up_for_freemium);
export const selectThemeSettings = (state) => ({
    font: state.app.data?.global_font,
    primaryColor: state.app.data?.primary_color,
    secondaryColor: state.app.data?.secondary_color,
})
export const selectIdleSeconds = (state) => state?.app?.data?.idle_seconds || 300
export const selectLogoSettings = (state) => state?.app?.data?.website_logo || null
export const selectAppTitle = (state) => state.app.data?.website_name || 'TruCount'
export const selectFaviconUrl = (state) => state.app.data?.favicon || '' // empty refers to default favicon.co
export default appSlice.reducer
